function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 18C4.0293 18 0 13.9707 0 9C0 4.0293 4.0293 0 9 0C13.9707 0 18 4.0293 18 9C18 13.9707 13.9707 18 9 18ZM9 7.2C8.7613 7.2 8.53239 7.29482 8.3636 7.4636C8.19482 7.63239 8.1 7.8613 8.1 8.1V12.6C8.1 12.8387 8.19482 13.0676 8.3636 13.2364C8.53239 13.4052 8.7613 13.5 9 13.5C9.23869 13.5 9.46761 13.4052 9.6364 13.2364C9.80518 13.0676 9.9 12.8387 9.9 12.6V8.1C9.9 7.8613 9.80518 7.63239 9.6364 7.4636C9.46761 7.29482 9.23869 7.2 9 7.2ZM9 6.3C9.23869 6.3 9.46761 6.20518 9.6364 6.0364C9.80518 5.86761 9.9 5.63869 9.9 5.4C9.9 5.1613 9.80518 4.93239 9.6364 4.7636C9.46761 4.59482 9.23869 4.5 9 4.5C8.7613 4.5 8.53239 4.59482 8.3636 4.7636C8.19482 4.93239 8.1 5.1613 8.1 5.4C8.1 5.63869 8.19482 5.86761 8.3636 6.0364C8.53239 6.20518 8.7613 6.3 9 6.3Z",
  fill: "#2A67F4"
});

function SvgIcWarningBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarningBlue);
export default ForwardRef;